import { render, staticRenderFns } from "./navigation-bar.vue?vue&type=template&id=6136d632&scoped=true&"
import script from "./navigation-bar.vue?vue&type=script&lang=js&"
export * from "./navigation-bar.vue?vue&type=script&lang=js&"
import style0 from "./navigation-bar.vue?vue&type=style&index=0&id=6136d632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136d632",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAppBar,VBtn,VIcon,VImg,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6136d632')) {
      api.createRecord('6136d632', component.options)
    } else {
      api.reload('6136d632', component.options)
    }
    module.hot.accept("./navigation-bar.vue?vue&type=template&id=6136d632&scoped=true&", function () {
      api.rerender('6136d632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application-level/navigation-bar.vue"
export default component.exports